/** @file Affine from a mesh attachment's image pixels (y-down) to slot-bone space (y-up). */
import type { Affine } from '@pose2d/math/types';
import { fitPixelAffine } from '../_internal/load/fitPixelAffine';
import { regionPixelToLocal } from './regionPixelToLocal';

/**
 * A rigid mesh (`vertices` given): the least-squares pixel -> vertex fit over its UVs (0..1 of the origW × origH
 * image). A skinned mesh (`vertices` null) or collinear UVs: the centred image frame. The loader places a mesh
 * handle with it and the compiler bakes a mounted rigid mesh with it.
 */
export function meshPixelToLocal(uvs: ArrayLike<number>, origW: number, origH: number, vertices: ArrayLike<number> | null): Affine {
  const fit = vertices === null ? null : fitPixelAffine(uvs, origW, origH, vertices);
  return fit ?? regionPixelToLocal({ x: 0, y: 0, rotation: 0, scaleX: 1, scaleY: 1, w: origW, h: origH, origW, origH });
}
